import {OfferListSubType} from "../types/OfferListSubType";

export const floorFilterFriendlyQueryValues: string[] = [OfferListSubType.FLOOR_GROUND, OfferListSubType.FLOOR_GROUND_WITH_GARDEN, OfferListSubType.LAST_FLOOR];
import {OfferListSubType} from "../types/OfferListSubType";

export const floorFilterFriendlyQueryValues: string[] = [OfferListSubType.FLOOR_GROUND, OfferListSubType.FLOOR_GROUND_WITH_GARDEN, OfferListSubType.LAST_FLOOR];
